import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient } from '@/services/core/apiClient';
import { useErrorHandler } from '@/hooks/useErrorHandler';

interface UseDeleteUserGroupResult {
  deleting: boolean;
  deleteUserGroup: (userGroupId: number) => Promise<boolean>;
}

export const useDeleteUserGroup = (): UseDeleteUserGroupResult => {
  const { token, user: authUser } = useAuth();
  const { handleError, handleSuccess } = useErrorHandler();
  const [deleting, setDeleting] = useState(false);

  const deleteUserGroup = async (userGroupId: number): Promise<boolean> => {
    if (!authUser?.id || !userGroupId) {
      handleError('Authentication required');
      return false;
    }

    setDeleting(true);

    try {
      const endpoint = `/api/ngpep/${authUser.id}/usergroup/${userGroupId}`;
      const response = await apiClient.delete(endpoint, token);

      if (response.success) {
        handleSuccess('User group deleted successfully');
        return true;
      } else {
        handleError(response.error || 'Failed to delete user group');
        return false;
      }
    } catch (err) {
      handleError(err, 'Failed to delete user group');
      return false;
    } finally {
      setDeleting(false);
    }
  };

  return {
    deleting,
    deleteUserGroup,
  };
};
